import React, { useState, useEffect, useContext } from "react";
import ServiceList from "../components/ServiceList";
import axiosHttp from "../config/axios.interceptor";
import { AppContext } from "../contexts/AppContext";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { AuthContext } from "../contexts/AuthContext";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { errorResponseMessage } from "../shared/const.prop";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import info from "../img/info.png";
import moment from "moment-timezone";
// import moment from "moment";
import DualCalendar from "../components/DualCalendar";
import { userReducerConstant } from "../store/reducerConstant";
import { getuserInfo } from "../store/actions/userActions";
import TimeSlotDisplay from "../components/TimeSlotDisplay";

const Service = ({ isOtherUser = false }) => {
  const appContext = useContext(AppContext);
  const currentDate = new Date();
  const { user, logout } = useContext(AuthContext);
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const [serviceList, setServiceList] = useState([]);
  const [slotDate, setSlotDate] = useState();
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [availableTimes, setAvailableTimes] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(currentDate);
  const [zone, setZone] = useState("");
  const [singleAvailableDate, setSingleAvailableDate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(userData?.offerService);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [response, setResponse] = useState({});
  const [otherProfile, setOtherProfile] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [otherProfileOffering, setOtherProfileOffering] = useState({});
  const [timeSlot, setTimeSlot] = useState({
    loading: false,
    error: false,
  });
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      appContext.openModal === false &&
      appContext.pendingAction === "fetchService"
    ) {
      setLoading(true);
      fetchService();
      appContext.resetPendingAction();
    } else if (
      appContext.openModal === false &&
      appContext.pendingAction?.name === "confirmAction"
    ) {
      let { data, isEdit } = appContext.pendingAction;

      // Create new object structure
      const newProduct = {
        name: data.productName,
        product_offerings_type_id: data.type,
        link: data.url,
      };

      if (isEdit) {
        // Update existing product
        setResponse((prevState) => ({
          ...prevState,
          profileOffering: prevState.profileOffering.map((item) =>
            item._id === data._id ? { ...item, ...newProduct } : item
          ),
        }));
      } else {
        // Add new product
        setResponse((prevState) => ({
          ...prevState,
          profileOffering: [...(prevState.profileOffering || []), newProduct],
        }));
      }

      // Reset pending action
      appContext.resetPendingAction();
    }
  }, [appContext.openModal, appContext.pendingAction]);

  const subscriptionPlan =
    user?.subscription?.main_plan_name ||
    user?.data?.data?.subscription?.main_plan_name;

  useEffect(() => {
    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
    // if (isOtherUser) {
    //   fetchProfile();
    // }
    fetchService();
  }, []);

  useEffect(() => {
    fetchProductOffering();
  }, []);

  const fetchProductOffering = async () => {
    try {
      const getProductOfferingList = await axiosHttp.get(
        `select-product-offering-types`
      );
      if (getProductOfferingList.status === 200) {
        let data = getProductOfferingList.data.data;
        setCategoryList(data);
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setCategoryList([]);
    }
  };

  const fetchProfile = (serviceData) => {
    axiosHttp
      .get("profile/" + id)
      .then((apiResponse) => {
        if (apiResponse.status === 200) {
          let temp = [...serviceData];
          let fl = {};
          // setOtherProfile(apiResponse?.data?.data ?? {});
          if (apiResponse?.data?.data?.isFreelancing) {
            (fl.serviceName = "Freelancing"),
              (fl.amount = apiResponse?.data?.data?.chargesPerHour),
              (fl.status = "Send Query");
            fl.id = "fl";
            fl.service_status = true;
          }
          if (apiResponse?.data?.data?.isFreelancing) {
            temp.push(fl);
          }
          setOtherProfile(apiResponse?.data?.data?.subscription);
          setServiceList(temp);
          // setOtherProfileOffering(apiResponse?.data?.data?.profile_offering);
          setOtherProfileOffering({
            offerService: apiResponse.data.data.offerService || false,
            isProfileOffering:
              apiResponse.data.data.is_profile_offering || false,
            profileOffering: apiResponse?.data?.data?.profile_offering || [],
          });
          setLoading(false);
        } else {
          appContext.updateNotificationState({
            show: true,
            type: "error",
            message: "Error, please try after sometime.",
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          logout();
        }
        if (error.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
        }
        appContext.updateNotificationState({
          show: true,
          type: "error",
          message: "Error, please try after sometime.",
        });
        setLoading(false);
      });
  };

  const myZone = localStorage.getItem("zone");

  const getTimeZone = async (start) => {
    // const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const timeZone = await axiosHttp.get(`timezone`);
      if (timeZone.status === 200) {
        let data = timeZone?.data?.data;
        setTimeZoneList(data);
        const myTimeZone = data.find((item) => {
          const { utc } = item;
          return utc.includes(myZone);
        });

        setZone(myTimeZone?._id?.$oid);
        fetchNewSlots(start, myTimeZone?._id?.$oid);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
    const formattedDate = moment(date).format("YYYY-MM-DD");
    // fetchAvailableSlots(formattedDate);
    fetchNewSlots(formattedDate, zone);
  };

  const currentTimeInUTC = moment().format("YYYY-MM-DDTHH:mm:ss[Z]");

  const fetchAvailableSlots = async (date, zone) => {
    const userId = localStorage.getItem("userId");
    try {
      const getSlots = await axiosHttp.get(
        isOtherUser
          ? `users/${id}/slots?zoneId=${zone}&date=${date}T00:00:00Z`
          : `users/${userId}/slots?zoneId=${zone}&date=${date}T00:00:00Z`
      );
      let data = getSlots?.data?.data;
      setAvailableTimes(data);
      setLoading(false);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });

        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
      setAvailableTimes([]);
    }
  };

  const fetchNewSlots = async (start, zone) => {
    const userId = localStorage.getItem("userId");
    const end = moment(start).add(3, "months").format("YYYY-MM-DD");
    setTimeSlot({ loading: true, error: false });
    try {
      const getSlots = await axiosHttp.get(
        isOtherUser
          ? `users/${id}/new-slots?startDate=${start}T00:00:00Z&endDate=${end}T00:00:00Z&zone=${zone}`
          : `users/${userId}/new-slots?startDate=${start}T00:00:00Z&endDate=${end}T00:00:00Z&zone=${zone}`
      );
      let data = getSlots?.data?.data;
      let filteredData = data.find((item) => {
        return moment(item.date).format("YYYY-MM-DD") === start;
      });
      let filteredSlots = filteredData?.slots;
      setAvailableTimes(data);
      setSingleAvailableDate(filteredSlots);
      setTimeSlot({ loading: false, error: false });
      setLoading(false);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });

        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
      setAvailableTimes([]);
      setSingleAvailableDate([]);
      setTimeSlot({ loading: false, error: true });
    }
  };

  const fetchAvailability = async (id) => {
    try {
      const getAvailabilityList = await axiosHttp.get(
        `users/${id}/queries?status=Answered`
      );
      let data = getAvailabilityList?.data?.data;
      setLoading(false);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });

        logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const isUserGoogle = user?.google_gmail || user?.data?.data?.google_gmail;

  const fetchService = async () => {
    const start = moment().tz(myZone).format("YYYY-MM-DD");
    getTimeZone(start);
    if (isOtherUser) {
      setLoading(true);
      try {
        const getOthersServiceList = await axiosHttp.get(
          `users/${id}/services`
        );
        if (getOthersServiceList.status === 200) {
          let data = getOthersServiceList?.data?.data;
          fetchProfile(data);
        }
      } catch (error) {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          logout();
        }
        if (error.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
        }
        if (error.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
        }
        fetchProfile([]);
        setLoading(false);
      }
    } else {
      fetchOfferService();
    }
  };

  const editHandler = (data) => {
    appContext.updateModalType("addEditService", "Edit Service", {
      ...data,
      categoryList,
    });
  };

  const editProductHandler = (data) => {
    appContext.updateModalType("addEditProduct", "Edit Product Offering", {
      ...data,
      categoryList,
      isEdit: true,
    });
  };

  const deleteProductHandler = async (item) => {
    if (item._id === undefined) {
      setResponse((prevState) => ({
        ...prevState,
        profileOffering: prevState.profileOffering.filter((i) => i !== item),
      }));
      return;
    }
    try {
      const response = await axiosHttp.delete(`product-offering/${item._id}`);
      if (response.status === 200) {
        fetchService();
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        logout();
        return;
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(e),
        type: "error",
      });
    }
  };

  const deleteHandler = async (service) => {
    setServiceList((prevServices) =>
      prevServices.map((s) =>
        s.id === service.id
          ? { ...s, service_status: !service.service_status }
          : s
      )
    );
  };

  const updateService = async () => {
    if (subscriptionPlan === "Basic") {
      appContext.updateModalType("subscriptionAlert", "Subscription", {
        name: subscriptionPlan,
        content: "Please subscribe to premium plan to avail this service",
      });
      return;
    }
    let payload = { ...response, services: serviceList };

    if (payload.offerService === false) {
      payload.isUpskillingServices = false;
      payload.isFreelancing = false;
    }
    if (payload.isUpskillingServices === null) {
      payload.isUpskillingServices = false;
    }
    if (payload.isFreelancing === null) {
      payload.isFreelancing = false;
    }
    if (payload.charges_per_hour === null) {
      payload.chargesPerHour = 0;
    }
    // }
    const {
      userId,
      fullName,
      userServices,
      charges_per_hour,
      profileOffering,
      ...rest
    } = payload;
    let updatedProfileOffering = profileOffering?.map((item) => ({
      name: item.name,
      product_offerings_type_id: item.product_offerings_type_id,
      link: item.link,
      ...(item._id && { _id: item._id }),
    }));
    try {
      const getServiceResponse = await axiosHttp.post("offer-service", {
        ...rest,
        chargesPerHour: payload.charges_per_hour,
        profileOffering: updatedProfileOffering || [],
      });
      if (getServiceResponse.status === 201) {
        fetchOfferService();
        dispatch(getuserInfo());
        appContext.updateNotificationState({
          show: true,
          message: "saved changes",
          type: "success",
        });
      }
    } catch (e) {
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(e),
        type: "error",
      });
    }
  };

  // const toggleProductOffering = (value) => {
  //   try {
  //     axiosHttp.post("toggle-profile-offering", {
  //       status: value,
  //     });
  //   } catch (error) {
  //     appContext.updateNotificationState({
  //       show: true,
  //       message: errorResponseMessage(error),
  //       type: "error",
  //     });
  //   }
  // };

  const fetchOfferService = async () => {
    try {
      const getServiceResponse = await axiosHttp.get("offer-service");
      if (getServiceResponse.status === 200) {
        setResponse(getServiceResponse?.data?.data);
        setServiceList(getServiceResponse?.data?.data?.userServices);
        setLoading(false);
      }
    } catch (e) {
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(e),
        type: "error",
      });
    }
  };

  const handleSlotDate = (nextValue) => {
    setSlotDate(nextValue);
    let formattedDate = moment(nextValue).tz(myZone).format("YYYY-MM-DD");
    setSlot({ ...slot, date: formattedDate });
    const index = bookingsList.findIndex(
      (element) => element.date === formattedDate
    );
    index !== -1 && setSlotIndex(index);
  };

  const tileDisabled = ({ date }) => {
    const formattedDate = moment(date).tz(myZone).format("YYYY-MM-DD");
    return !availableDates.includes(formattedDate) ? true : null;
  };

  const selectedValue = timeZoneList.find(
    (option) => option._id?.$oid === zone
  );

  const hanldleTimezoneChange = (selectedOption) => {
    setZone(selectedOption.value);
    const date = moment(selectedDate).format("YYYY-MM-DD");
    fetchNewSlots(date, selectedOption.value);
  };

  return (
    <div className="serv-card">
      <div className="post">
        <div className="card card-one-1 mb-5 margin">
          <div className="card-body">
            <div className="row mb-2 align-center">
              <div className="align-items-center justify-content-between w-100 pad-lr-15">
                <div>
                  <div className="row">
                    {!isOtherUser && (
                      <div className="form-group col-9 col-md-10">
                        {subscriptionPlan === "Basic" && (
                          <p>
                            * Premium subscription required to avail this
                            service
                          </p>
                        )}
                        <div className="d-flex align-items-center">
                          <label className="switch-label">
                            <span className="d-flex align-items-center">
                              <p className="service-head"> Services Offered</p>
                              <div className="tool-tip">
                                <div className="info-icon">
                                  <img src={info} alt="info" />
                                </div>
                                <div className="tooltiptext left-hover">
                                  Empower your mentoring journey with flexible
                                  service options tailored to your needs. Choose
                                  from single sessions for quick insights,
                                  weekly engagements for consistent progress, or
                                  monthly packages for comprehensive support.
                                  Customize your experience and make the most of
                                  your mentorship with our versatile service
                                  offerings.
                                </div>
                              </div>
                            </span>
                          </label>
                          <label class="switch ml-3">
                            <input
                              type="checkbox"
                              checked={response?.offerService}
                              onChange={() =>
                                setResponse({
                                  ...response,
                                  offerService: !response?.offerService,
                                })
                              }
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                    )}
                    {!isOtherUser && (
                      <div className="col-3 col-md-2">
                        <button
                          class="btn btn-primary btn-reel service-save-btn"
                          onClick={updateService}
                        >
                          Save
                        </button>
                      </div>
                    )}
                  </div>
                  {!isOtherUser && response?.offerService && (
                    <div className="form-group ">
                      <div className="d-flex align-items-center">
                        <label className="switch-label">
                          <span className="service-secondary-head">
                            Upskilling services{" "}
                          </span>
                        </label>
                        <label class="switch ml-3">
                          <input
                            type="checkbox"
                            checked={response?.isUpskillingServices}
                            onChange={() => {
                              if (response.isUpskillingServices === null) {
                                setResponse({
                                  ...response,
                                  isUpskillingServices: true,
                                });
                              } else {
                                setResponse({
                                  ...response,
                                  isUpskillingServices:
                                    !response?.isUpskillingServices,
                                });
                              }
                            }}
                          />
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </div>
                  )}
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  {!isOtherUser &&
                    response?.offerService &&
                    response?.isUpskillingServices && (
                      <p className="title mb-0 service-sub-head">
                        {!isOtherUser ? "Add Services" : "Services"}
                      </p>
                    )}
                  {response?.offerService && response?.isUpskillingServices && (
                    <div>
                      {!isOtherUser &&
                        isUserGoogle &&
                        serviceList.length < 3 && (
                          <button
                            className="btn btn-primary btn-reel rounded-pill"
                            onClick={() =>
                              appContext.updateModalType(
                                "addEditService",
                                "Add Service"
                              )
                            }
                          >
                            Add
                          </button>
                        )}
                    </div>
                  )}
                </div>
                {isOtherUser && <p className="title mb-0">Services</p>}
              </div>
            </div>
            {response?.offerService && response?.isUpskillingServices && (
              <div>
                {!isOtherUser && !isUserGoogle && (
                  <p>
                    {" "}
                    Add your Google account in the calendar before adding the
                    service
                  </p>
                )}
              </div>
            )}
            {/* <p className="sub-txt">View Services</p> */}
            {!isOtherUser &&
              response?.offerService &&
              response?.isUpskillingServices &&
              isUserGoogle && (
                <ServiceList
                  loading={loading}
                  serviceList={serviceList}
                  editHandler={editHandler}
                  deleteHandler={deleteHandler}
                  isOtherUser={isOtherUser}
                />
              )}
            {isOtherUser && (
              <ServiceList
                loading={loading}
                serviceList={serviceList}
                editHandler={editHandler}
                deleteHandler={deleteHandler}
                isOtherUser={isOtherUser}
                otherProfile={otherProfile}
              />
            )}
            {response?.offerService && (
              <div>
                <div className="form-group ">
                  <div className="d-flex align-items-center">
                    <label className="switch-label">
                      <span className="service-secondary-head">
                        Business consulting service{" "}
                      </span>
                    </label>
                    <label class="switch ml-3">
                      <input
                        type="checkbox"
                        checked={response?.isFreelancing}
                        onChange={() =>
                          setResponse({
                            ...response,
                            isFreelancing: !response?.isFreelancing,
                          })
                        }
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
                {response.isFreelancing && (
                  <div className="form-group">
                    <label>Charges per hour</label>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="input-group flex-gp mb-4">
                          <div className="input-group-prepend">
                            <span
                              className="input-group-text addon-icon bg-transparent"
                              id="basic-addon1"
                            >
                              {/* {symbol ? symbol : "₹"} */}₹
                            </span>
                          </div>
                          <input
                            type="number"
                            className="form-control"
                            inputMode="numeric"
                            min="0"
                            // max="9999"
                            id="myNumberInput"
                            name="amount"
                            onChange={(e) =>
                              setResponse({
                                ...response,
                                charges_per_hour: e.target.value,
                              })
                            }
                            value={response.charges_per_hour}
                            onKeyDown={(e) => {
                              if (
                                !(
                                  (
                                    (e.key >= "0" && e.key <= "9") || // Allow digits
                                    e.key === "Backspace" || // Allow Backspace
                                    e.key === "Delete" || // Allow Delete
                                    e.key === "ArrowLeft" || // Allow Left Arrow
                                    e.key === "ArrowRight" || // Allow Right Arrow
                                    e.key === "Tab"
                                  ) // Allow Tab
                                )
                              ) {
                                e.preventDefault();
                              }
                            }}
                            pattern="[0-9]*"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {(isOtherUser
              ? otherProfileOffering?.offerService &&
                otherProfileOffering?.profileOffering.length > 0
              : response?.offerService) && (
              <div>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="d-flex align-items-center">
                      <label className="switch-label">
                        <span className="service-secondary-head">
                          e-Product Offerings
                        </span>
                      </label>
                      {!isOtherUser && (
                        <label className="switch ml-3">
                          <input
                            type="checkbox"
                            checked={response?.isProfileOffering}
                            onChange={() => {
                              setResponse({
                                ...response,
                                isProfileOffering: !response?.isProfileOffering,
                              });
                              // toggleProductOffering(
                              //   !response?.isProfileOffering
                              // );
                            }}
                          />
                          <span className="slider round"></span>
                        </label>
                      )}
                    </div>
                  </div>
                  {!isOtherUser && response.isProfileOffering && (
                    <button
                      className="btn btn-outline-primary follow-btn"
                      onClick={() =>
                        appContext.updateModalType(
                          "addEditProduct",
                          "Add Product Offering",
                          { categoryList: categoryList }
                        )
                      }
                    >
                      Add
                    </button>
                  )}
                </div>

                {/* Table Section */}
                {((isOtherUser &&
                  otherProfileOffering.isProfileOffering &&
                  otherProfileOffering.profileOffering?.length > 0) ||
                  (!isOtherUser &&
                    response.isProfileOffering &&
                    response.profileOffering?.length > 0)) && (
                  <div className="e-product-table">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>SI.NO</th>
                          <th>Product Name</th>
                          <th>Type</th>
                          <th>{isOtherUser ? "Link" : "Actions"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(isOtherUser
                          ? otherProfileOffering.profileOffering
                          : response.profileOffering
                        ).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.name}</td>
                            <td>
                              {/* {isOtherUser
                                ? categoryList.find(
                                    (cat) =>
                                      cat._id === item.product_offerings_type_id
                                  )?.name || item.product_offerings_type_id
                                : item?.type?.name} */}
                              {categoryList.find(
                                (cat) =>
                                  cat._id === item.product_offerings_type_id
                              )?.name || item.product_offerings_type_id}
                            </td>
                            <td>
                              {isOtherUser ? (
                                <a
                                  href={item.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View
                                </a>
                              ) : (
                                <>
                                  <span
                                    onClick={() => editProductHandler(item)}
                                    className="mr-3 cursor-pointer"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="15"
                                      height="17"
                                      viewBox="0 0 15 17"
                                      fill="none"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M12.4303 1.0447C12.472 1.0772 13.8661 2.16054 13.8661 2.16054C14.3728 2.4622 14.7686 3.00137 14.9186 3.6397C15.0678 4.27137 14.9595 4.92303 14.612 5.47387C14.6097 5.47754 14.6074 5.48117 14.5993 5.49197L14.593 5.50031C14.5366 5.57465 14.2914 5.8847 13.0539 7.43519C13.0424 7.45551 13.0294 7.47454 13.0151 7.49303C12.9943 7.52029 12.9716 7.54535 12.9473 7.56817C12.8629 7.67445 12.7738 7.78612 12.68 7.90353L12.4901 8.14142C12.0982 8.63223 11.6333 9.21424 11.0818 9.90455L10.7988 10.2588C9.73404 11.5914 8.37044 13.2977 6.62364 15.483C6.24114 15.9597 5.66781 16.2372 5.05198 16.2447L2.01948 16.283H2.01114C1.72198 16.283 1.47031 16.0847 1.40281 15.8022L0.72031 12.9097C0.579477 12.3105 0.719477 11.6922 1.10364 11.2122L8.95364 1.39387C8.95698 1.39054 8.95948 1.38637 8.96281 1.38304C9.82364 0.353869 11.3803 0.202202 12.4303 1.0447Z"
                                        fill="#575757"
                                      />
                                    </svg>
                                  </span>
                                  <span
                                    // onClick={() => deleteProductHandler(item)}
                                    onClick={() => {
                                      appContext.updateModalType(
                                        "deleteItem",
                                        "Delete Product Offering",
                                        {
                                          item,
                                          onDelete: deleteProductHandler,
                                        }
                                      );
                                    }}
                                    className="cursor-pointer"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="14"
                                      height="16"
                                      viewBox="0 0 14 16"
                                      fill="none"
                                    >
                                      <path
                                        d="M13 3.5H1M4.5 3.5V2C4.5 1.44772 4.94772 1 5.5 1H8.5C9.05228 1 9.5 1.44772 9.5 2V3.5M2.5 3.5L3 14.5C3 15 3.5 15.5 4 15.5H10C10.5 15.5 11 15 11 14.5L11.5 3.5"
                                        stroke="#FF0000"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </span>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
            <TimeSlotDisplay
              loading={timeSlot.loading}
              timeZoneList={timeZoneList}
              zone={zone}
              selectedValue={selectedValue}
              hanldleTimezoneChange={hanldleTimezoneChange}
              selectedDate={selectedDate}
              handleDateClick={handleDateClick}
              singleAvailableDate={singleAvailableDate}
              error={timeSlot.error}
              isCalendarDisplay={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
